export class S3JsonContentError extends Error {
  constructor(code, message) {
    super(message);
    this.name = "S3JsonContentError";
    this.code = code;
  }
}

function stripPathSuffix(path) {
  return String(path || "").split(/[?#]/, 1)[0];
}

export function getS3PathExtension(path) {
  const fileName = stripPathSuffix(path).split("/").pop() || "";
  const dotIndex = fileName.lastIndexOf(".");
  return dotIndex >= 0 ? fileName.slice(dotIndex + 1).toLowerCase() : "none";
}

export function isJsonS3Path(path) {
  return /\.json$/i.test(stripPathSuffix(path));
}

export function parseS3JsonText(text) {
  const content = String(text ?? "").replace(/^\uFEFF/, "");
  if (content.charCodeAt(0) === 0x50 && content.charCodeAt(1) === 0x4b) {
    throw new S3JsonContentError(
      "xlsx_zip_content",
      "Expected JSON content but received an XLSX/ZIP object.",
    );
  }

  try {
    return JSON.parse(content);
  } catch {
    throw new S3JsonContentError(
      "invalid_json_content",
      "Expected JSON content but received a non-JSON object.",
    );
  }
}
